import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@material-ui/core';
import SelectWithSearchV2 from 'src/components/SelectWithSearchV2';
import { isIsoDate, normalizeOptions } from 'src/utils/dashboardKVSUtils';

const AddPageDialog = ({
  open,
  onClose,
  onSubmit,
  pageLabel,
  dialogPageIds,
  setDialogPageIds,
  pageOptions,
  pagesLoading,
  selectedDate,
  dialogError
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{`Add ${pageLabel}`}</DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection="column" gridGap={16}>
          <SelectWithSearchV2
            label={pageLabel}
            value={dialogPageIds || []}
            onChange={event => {
              const nextValue = Array.isArray(event.target.value)
                ? event.target.value
                : [event.target.value].filter(Boolean);
              setDialogPageIds(nextValue);
            }}
            options={normalizeOptions(pageOptions)}
            searchKeys={['label', 'description']}
            disabled={pagesLoading || !pageOptions.length}
            helperText={
              pagesLoading
                ? 'Loading choices…'
                : !pageOptions.length
                ? `No ${pageLabel.toLowerCase()} choices found.`
                : ''
            }
          />
          <Typography variant="body2" color="textSecondary">
            {`Date: ${
              selectedDate
                ? isIsoDate(selectedDate)
                  ? selectedDate
                  : `Key ${selectedDate}`
                : 'Select a date from the picker above.'
            }`}
          </Typography>
          {dialogError && (
            <Typography color="error" variant="body2">
              {dialogError}
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={pagesLoading}>
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={onSubmit}
          disabled={pagesLoading}
        >
          {`Add ${pageLabel}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddPageDialog;
